import { Heading2 } from 'components/shared/Typography.styled';
import { useI18n } from 'hooks/useI18n';
import { OwnTeam } from 'interfaces/own-team.interface';
import { Tech } from 'model';
import Masonry from 'react-masonry-css';
import { config } from 'utils/config';
import BringYourOwnTeamCard from './BringYourOwnTeamCard';
import { StyledContainer, StyledGrid } from './BringYourOwnTeamTeams.styled';

type BringYourOwnTeamTeamsProps = { techs: Tech[]; teams: OwnTeam[] };

const BringYourOwnTeamTeams: React.FC<BringYourOwnTeamTeamsProps> = ({
  techs,
  teams
}) => {
  const { t } = useI18n('bring-your-own-team');

  const breakpointColumnsObj = {
    default: 3,
    1000: 2,
    630: 1
  };

  type TechItemProp = {
    tech: string;
    icon: string;
  };

  const isTech = (
    item: TechItemProp | undefined | null
  ): item is TechItemProp => {
    return !!item;
  };

  const teamsTechs = teams.map((team) => {
    return {
      ...team,
      stack: team.stack
        .map((techId) => {
          const tech = techs.find((tech) => tech.id === techId);

          if (!tech) {
            return null;
          }

          return {
            tech: tech.name,
            icon: tech.icon?.url || config.defaultTechIcon
          };
        })
        .filter(isTech)
    };
  });

  if (teamsTechs.length <= 0) {
    return null;
  }

  return (
    <StyledContainer id="teams">
      <Heading2 editorial>{t('teams.title')}</Heading2>
      <StyledGrid>
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="masonry-grid"
          columnClassName="masonry-column"
        >
          {teamsTechs.map((t, i) => (
            <BringYourOwnTeamCard key={i} team={t} />
          ))}
        </Masonry>
      </StyledGrid>
    </StyledContainer>
  );
};

export default BringYourOwnTeamTeams;
